import {JsonObject, JsonProperty} from "json2typescript";

import {JsonPropertyEmpty} from "../../utils/json-util";

@JsonObject("MediaDeleteOutput")
export class MediaDeleteOutput {
    @JsonProperty("status", String)
    public status: string = JsonPropertyEmpty;
}
